import React from 'react'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { NumberField, TextField } from 'src/Libs/inputs/formik'
import { MeasurementsFormDataKeys } from '../../models/measurements'

const useStyles = makeStyles()(theme => ({
  formStyle: {
    margin: 0,
    padding: 0,
  },
}))

const MeasurementsForm: React.VFC = () => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()

  return (
    <form className={classes.formStyle}>
      <Typography sx={{ py: 2 }} variant="h5">
        {t('installation-statement.measurement.device.title')}
      </Typography>
      <Stack spacing={4}>
        <TextField
          required
          name={MeasurementsFormDataKeys.MeasurementDeviceManufacturer}
          label={t('installation-statement.measurement.device.manufacturer')}
        />
        <TextField required name={MeasurementsFormDataKeys.MeasurementDeviceType} label={t('installation-statement.measurement.device.type')} />
      </Stack>

      <Typography sx={{ pt: 4, pb: 2 }} variant="h5">
        {t('installation-statement.measurement.impedanceLoop.title')}
      </Typography>
      <Stack spacing={4}>
        <NumberField
          name={MeasurementsFormDataKeys.LoopImpedanceNL1}
          label={t('installation-statement.measurement.loopImpedanceNL1')}
          isDecimal
          precision={2}
          ignoreDefaultValue
        />
        <NumberField
          name={MeasurementsFormDataKeys.LoopImpedanceNL2}
          label={t('installation-statement.measurement.loopImpedanceNL2')}
          isDecimal
          precision={2}
          ignoreDefaultValue
        />
        <NumberField
          name={MeasurementsFormDataKeys.LoopImpedanceNL3}
          label={t('installation-statement.measurement.loopImpedanceNL3')}
          isDecimal
          precision={2}
          ignoreDefaultValue
        />
        <NumberField
          name={MeasurementsFormDataKeys.LoopImpedancePEL}
          label={t('installation-statement.measurement.loopImpedancePEL')}
          isDecimal
          precision={2}
          ignoreDefaultValue
        />
      </Stack>
    </form>
  )
}

export default MeasurementsForm
